import type { ReplyStats } from "hooks/use-email-replies-api";
import type { FC } from "react";

export type ReplyDashboardHeaderProps = {
  stats: ReplyStats | null;
};

/**
 * 返信管理画面のヘッダー統計
 * @param {ReplyDashboardHeaderProps} props props
 * @return {JSX.Element} header
 */
export const ReplyDashboardHeader: FC<ReplyDashboardHeaderProps> = ({
  stats,
}) => {
  const total = stats?.total ?? 0;
  const unresponded = stats?.unresponded ?? 0;
  const inProgress = stats?.inProgress ?? 0;
  const completed = stats?.completed ?? 0;
  const rate = stats ? Math.round(stats.responseRate * 100) : 0;

  return (
    <div className="bg-white rounded-lg border border-slate-200 px-4 py-2 flex items-center gap-6 text-sm">
      <h1 className="font-bold text-base">返信管理</h1>
      <div className="flex gap-4 flex-1">
        <Stat label="総件数" value={total} />
        <Stat label="未対応" value={unresponded} tone="error" />
        <Stat label="対応中" value={inProgress} tone="warning" />
        <Stat label="完了" value={completed} tone="success" />
        <Stat label="対応率" value={`${rate}%`} />
      </div>
    </div>
  );
};

type StatProps = {
  label: string;
  value: number | string;
  tone?: "error" | "warning" | "success";
};

/**
 * 個別の統計セル
 * @param {StatProps} props props
 * @return {JSX.Element} stat
 */
const Stat: FC<StatProps> = ({ label, value, tone }) => {
  const color = toneClass(tone);
  return (
    <div className="flex items-baseline gap-1">
      <span className="text-xs text-slate-500">{label}:</span>
      <span className={`font-bold ${color}`}>{value}</span>
    </div>
  );
};

/**
 * tone → Tailwind color クラス
 * @param {string|undefined} tone トーン
 * @return {string} クラス
 */
function toneClass(tone?: "error" | "warning" | "success"): string {
  switch (tone) {
    case "error":
      return "text-rose-600";
    case "warning":
      return "text-amber-600";
    case "success":
      return "text-emerald-600";
    default:
      return "text-slate-700";
  }
}
